//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-323843 - Remove feature check once Ambassador Targeting is released
export const getIsAmbassadorTargetingEnabled = createHasFeatureSelector(
  FeatureNames.VibeAmbassadorsTargeting,
);
